import { Component, ViewChildren, QueryList, ApplicationRef } from '@angular/core';
import { NavController }                                      from 'ionic-angular';
import { LoadingController }                                  from 'ionic-angular';
import { dmHotel }                                            from '../sign-in/xv-hotel';
import { RoomsViewModel }                                     from './xv-rooms';
import { MLText, mlBroker }                                   from '../../services/MLText';
import { AppDataBroker }                                      from '../../services/AppData';
import { SignInPage }                                         from '../sign-in/sign-in';
import { dmLoading }                                          from '../loading/loading';
import { AlertController }                                    from 'ionic-angular';

@Component({
     selector:    'page-rooms'
    ,templateUrl: 'rooms.html'
})
export class RoomsPage {
    @ViewChildren('inputs') inputs: QueryList<any>;

    Rooms:         RoomsViewModel;
    NewLoading:    (pMessage: string)                 => dmLoading;
    ShowAlert:     (pTitle: string ,pMessage: string) => void;
    FocusNext:     (pIndex: number)                   => void;
    BackToSignIn:  ()                                 => void;

    app:           mlBroker;

    Application:   ApplicationRef;

    constructor(
         public navCtrl:        NavController
        ,public loadingCtrl:    LoadingController
        ,public mlText:         MLText
        ,public appDataBroker:  AppDataBroker
        ,public alertCtrl:      AlertController
        ,public applicationRef: ApplicationRef
    ) {
        let hotel        = appDataBroker.GetAppData() as dmHotel;

        this.app         = this.mlText.GetBroker('BookingEngineAppTexts');

        this.Application = applicationRef;

        this.ShowAlert = (pTitle: string, pMessage: string) => {
            let alert = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.FocusNext = (pIndex: number) => {
            if (this.inputs.toArray().length > (pIndex + 1)) {
                console.log('setting focus: index - ' + (pIndex + 1));

                this.Application.tick();

                this.inputs.toArray()[pIndex + 1].setFocus();
            }
        };

        this.Rooms = new RoomsViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.NewLoading
            ,this.ShowAlert
            ,this.FocusNext
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/rooms/rooms.ts